<template>
  <div class="sap-wrap">
    <h1>SAP – Synchronisation
    </h1>
  </div>
</template>

<script setup>
</script>

<style scoped>

</style>
